import { Component } from "react";

export default class ModalBody extends Component {
  render() {
    const { className, children } = this.props;

    return <div className={`Modal-body ${className || ""}`}>{children}</div>;
  }
}
